import useRequest, {
    RequestFn,
    RequestKeys,
} from 'app/hooks/useRequest'
import aPricingRateCardRequests from 'app/requests/APricingRateCard/APricingRateCard.requests'

export default function useGetAPricingRateCard(id: number) {
    return useRequest({
        key: RequestKeys.getAPricingRateCardById,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(aPricingRateCardRequests.getById),
        enabled: Boolean(id),
    })
}
